/* @flow */
import moment from 'moment';
import { connect } from 'react-redux';

import { fetchTransactions } from 'ducks/list';
import { api } from 'utils/ajax';
import Td from 'components/UIKit/Table/Td';
import Button from 'components/UIKit/Button/Button';
import ParamsLink from 'components/Links/ParamsLink';
import Spinner from 'components/UIKit/Spinner/Spinner';
import TransactionIcon from 'components/icons/TransactionIcon';
import DATE_FORMAT from 'constants/date';
import { showOptimisticPendingTransaction } from 'ducks/uploadTransactions';

import type { Transaction } from 'models/transactions';
import TrLink from '../TrLink';

type TransactionsRowProps = {
  router: Object,
  children: Transaction,
  i: number,
  projects: Object,
  dispatch: () => {}
}

function TransactionsRow({
  children, router, i, projects, dispatch,
}: TransactionsRowProps): React.Element {
  const newQuery = { did: children.id };
  const isActiveItem = children.id
    && (router.location.query.did === children.id);

  const projectId = `${router.params.program}-${router.params.project}`;
  const project = projects.items.find(p => p.project_id === projectId) || {};

  return (
    <TrLink
      customDataTestID={`row-${i+1}`}
      isActiveItem={isActiveItem}
      linkId={children.id}
      router={router}
      className={!i ? 'highlight' : ''}
      >
      <Td >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <TransactionIcon type={children.type} style={{ marginRight: '.5rem' }} />
          {isActiveItem
            ? children.id
            : (
              <ParamsLink customDataTestID='text-id' query={newQuery}>
                { children.id }
              </ParamsLink>
            )}
        </div>
      </Td>

      {children.state !== 'LOADING' && (
        <Td customDataTestID='text-type' style={{ textTransform: 'capitalize' }}>
          {children.type}
        </Td>
      )}

      {children.state === 'LOADING' && <Td />}

      {children.state !== 'LOADING' && (
        <Td customDataTestID='text-step' style={{ textTransform: 'capitalize' }}>
          {children.is_dry_run ? 'Validate' : 'Commit'}
        </Td>
      )}

      {children.state === 'LOADING' && <Td />}

      {children.state !== 'LOADING' && (
        <Td customDataTestID='text-datetime'>
          {moment(children.created_datetime).format(DATE_FORMAT)}
        </Td>
      )}

      <Td customDataTestID='text-user'>{children.submitter}</Td>

      <Td customDataTestID='text-state'>
        {children.state === 'LOADING'
          ? <Spinner />
          : children.state
        }
      </Td>

      <Td customDataTestID='text-additional-info'>
        {(children.state === 'SUCCEEDED'
          && children.is_dry_run
          && !children.committed_by
          && !children.closed) && (
            <div>
              <Button
                disabled={project.state !== 'open'}
                onClick={(event) => {
                  api({
                    url: `${router.params.program}/${router.params.project}/transactions/${children.id}/commit?async=true`,
                    method: 'post',
                  });
                  dispatch(showOptimisticPendingTransaction());
                  event.stopPropagation();
                }}
                >
              commit
              </Button>
              &nbsp;
              <Button
                disabled={(project || { state: 'open' }).state !== 'open'}
                onClick={(event) => {
                  api({
                    url: `${router.params.program}/${router.params.project}/transactions/${children.id}/close`,
                    method: 'post',
                  });
                  dispatch(fetchTransactions({
                    first: 10,
                    offset: 0,
                    sort: 'created_datetime',
                    order: 'desc',
                    program: router.params.program,
                    project: router.params.project,
                    ...router.location.query,
                  }));
                  event.stopPropagation();
                }}
                >
                discard
              </Button>
            </div>
        )}

        {!!children.committed_by
          && `Commited by Transaction: ${children.committed_by}`
        }

        {!!children.closed && 'Discarded'}
      </Td>
    </TrLink>
  );
}

export default connect(({ projects }) => ({ projects }))(TransactionsRow);
